import * as yup from 'yup';

yup.addMethod<yup.StringSchema>(yup.string, 'phone', function phone() {
  return this.test('phone', 'Phone number required', (value: string | undefined) => {
    if (!value) {
      return false;
    }

    return value.trim().length > 0;
  });
});

export default yup;
